import { CLEAR_RSS_METADATA } from './actionTypes';

const clearRssMetadata = () => ({ type: CLEAR_RSS_METADATA });

export default clearRssMetadata;
